import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DepartmentService } from '../../../services/department.service';
import { ErrorService } from '../../../shared/services/error.service';

@Component({
  selector: 'app-department-form',
  templateUrl: './department-form.component.html',
  styleUrls: ['./department-form.component.css']
})
export class DepartmentFormComponent implements OnInit {
  departmentForm: FormGroup;
  isSubmitting = false;
  isEditMode = false;
  departmentId: number | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private departmentService: DepartmentService,
    private errorService: ErrorService
  ) {
    this.departmentForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(200)]],
      description: ['', Validators.maxLength(500)]
    });
  }

  ngOnInit(): void {
    // Verifica se é edição (rota com :id)
    this.route.paramMap.subscribe(params => {
      const idParam = params.get('id');
      if (idParam) {
        this.isEditMode = true;
        this.departmentId = Number(idParam);

        // Buscar dados do departamento para preencher o formulário (view antes de editar)
        this.departmentService.getDepartmentById(this.departmentId).subscribe({
          next: (department) => {
            this.departmentForm.patchValue({
              name: department.name,
              description: department.description || ''
            });
          },
          error: (err) => {
            this.errorService.handleHttpError(err);
          }
        });
      }
    });
  }

  onSubmit(): void {
    if (this.departmentForm.invalid) {
      this.departmentForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    const formValue = this.departmentForm.value;

    const departmentData = {
      name: formValue.name.trim(),
      description: formValue.description?.trim() || null,
      isActive: true, // por enquanto sempre ativo; pode ser estendido com campo no form
      managerStaffId: null
    };

    if (this.isEditMode && this.departmentId) {
      // EDITAR departamento existente
      this.departmentService.updateDepartment(this.departmentId, departmentData).subscribe({
        next: () => {
          this.isSubmitting = false;
          this.router.navigate(['/hr/departments']);
        },
        error: (err) => {
          this.errorService.handleHttpError(err);
          this.isSubmitting = false;
        }
      });
    } else {
      // CRIAR novo departamento
      this.departmentService.createDepartment(departmentData).subscribe({
        next: (response) => {
          this.isSubmitting = false;
          this.router.navigate(['/hr/departments']);
        },
        error: (err) => {
          this.errorService.handleHttpError(err);
          this.isSubmitting = false;
        }
      });
    }
  }

  onCancel(): void {
    this.router.navigate(['/hr/departments']);
  }

  getFieldError(fieldName: string): string {
    const field = this.departmentForm.get(fieldName);
    if (field && field.invalid && (field.touched || field.dirty)) {
      if (field.errors?.['required']) {
        return 'Campo obrigatório';
      }
      if (field.errors?.['minlength']) {
        return `Mínimo de ${field.errors['minlength'].requiredLength} caracteres`;
      }
      if (field.errors?.['maxlength']) {
        return `Máximo de ${field.errors['maxlength'].requiredLength} caracteres`;
      }
    }
    return '';
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.departmentForm.get(fieldName);
    return !!(field && field.invalid && (field.touched || field.dirty));
  }
}
